import { render, staticRenderFns } from "./Warn.vue?vue&type=template&id=1c9a00dc&scoped=true&"
var script = {}
import style0 from "./Warn.vue?vue&type=style&index=0&id=1c9a00dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9a00dc",
  null
  
)

export default component.exports